module.exports = __webpack_public_path__ + "static/media/battlehigh2.dcf8253e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/battlehigh2.png
 ** module id = 286
 ** module chunks = 0
 **/